define('sections/referrals/Podio.UI.Referrals.Landing',['require','jquery','jquery.scrollTo','lib/Podio.Event.UI'],function(require) {

  var $ = require('jquery');
  require('jquery.scrollTo');
  var eventUI = require('lib/Podio.Event.UI');

  function onReadMoreClicked(elmTarget, e) {
    if (history) {
      e.preventDefault();

      var targetHref = elmTarget.attr('href');
      var targetAnchor = targetHref.substr(1);
      var targetSelector = '#' + targetAnchor;

      $(window).scrollTo(targetSelector, { duration: 500, easing: 'swing' });
      history.pushState({}, '', targetHref);
    }
  }

  eventUI.bind('click', '#referral_signup_box_new .read-more a', onReadMoreClicked, true);

});

